(function () {
  var TIERS = null;
  var bundleHandles = { 'one-of-each-1': true };
  var initialized = false;

  function parseTiers() {
    var card = document.getElementById('CartDrawer-ProgressCard');
    if (!card) return false;

    var raw = card.getAttribute('data-tiers');
    if (!raw) return false;

    try {
      TIERS = JSON.parse(raw);
    } catch (e) {
      return false;
    }
    if (!TIERS || !TIERS.length) return false;

    var bundleHandlesRaw = (card.getAttribute('data-bundle-handles') || '').trim();
    if (bundleHandlesRaw) {
      bundleHandlesRaw.split(',').forEach(function (h) {
        h = h.trim();
        if (h) bundleHandles[h] = true;
      });
    }

    return true;
  }

  function isBundle(item) {
    if (bundleHandles[item.handle]) return true;
    /* Every One of Each bundle (one-of-each-1/-2, the Sharing is Caring deal),
       same rule as the tier-pricing function's handle.startsWith check. */
    if (item.handle && item.handle.indexOf('one-of-each') === 0) return true;
    if (item.product_type && /bundle/i.test(item.product_type)) return true;
    if (item.properties && item.properties._bundle) return true;
    return false;
  }

  /**
   * Volume 20%/33% must be measured on the selling-plan price *before*
   * automatic % off. If we use the post-33% line total, a $210 cart reads
   * as $140.70 and the bar says "add $159 for 33%" while 33% is already on.
   */
  function volumeProgressCents(item) {
    if (typeof item.original_line_price === 'number') return item.original_line_price;
    var orig = (Number(item.original_price) || 0) * (Number(item.quantity) || 1);
    if (orig) return orig;
    var linePrice = item.final_line_price;
    if (typeof linePrice !== 'number') {
      linePrice = (Number(item.final_price) || 0) * (Number(item.quantity) || 1);
    }
    return linePrice;
  }

  function isFreeShippingTier(tier) {
    if (!tier) return false;
    return /free\s*shipping/i.test((tier.reward || '') + ' ' + (tier.label || ''));
  }

  function updateTierUI(merchFull, merchNonBundle, paidFull, paidNonBundle, hasSubscription) {
    var c = document.getElementById('CartDrawer-ProgressCard');
    if (!c || !TIERS || !TIERS.length) return;

    var textEl = c.querySelector('[data-cart-tier-text]');
    var dots = c.querySelectorAll('[data-cart-tier-dot]');
    var lines = c.querySelectorAll('[data-cart-tier-line]');
    var labels = c.querySelectorAll('[data-cart-tier-label]');
    if (!textEl) return;

    labels.forEach(function (label, i) {
      if (!TIERS[i] || !TIERS[i].label) return;
      if (label.textContent !== TIERS[i].label) label.textContent = TIERS[i].label;
    });

    function amountFor(tier) {
      var usePaid = !!(tier && (tier.usePaidAmount || /free\s*shipping/i.test(tier.reward || '')));
      var includesBundles = !tier || tier.includesBundles !== false;
      if (usePaid) return includesBundles ? paidFull : paidNonBundle;
      return includesBundles ? merchFull : merchNonBundle;
    }

    // Any subscription in the cart ships free regardless of amount paid.
    function reached(tier) {
      if (hasSubscription && isFreeShippingTier(tier)) return true;
      return amountFor(tier) >= tier.threshold;
    }

    var points = [0];
    TIERS.forEach(function (t) { points.push(t.threshold); });

    dots.forEach(function (dot, i) {
      if (!TIERS[i]) return;
      dot.classList.toggle('cart-drawer__progress-dot--empty', !reached(TIERS[i]));
    });

    lines.forEach(function (line, i) {
      if (!TIERS[i]) return;
      var sub = amountFor(TIERS[i]);
      var segStart = points[i];
      var segEnd = points[i + 1];
      if (reached(TIERS[i])) {
        line.classList.add('cart-drawer__progress-line--filled');
        line.style.cssText = '';
      } else if (sub > segStart) {
        var pct = Math.min(((sub - segStart) / (segEnd - segStart)) * 100, 100);
        line.classList.remove('cart-drawer__progress-line--filled');
        line.style.cssText = 'background: linear-gradient(to right, #8B89B1 ' + pct + '%, #DDDCE8 ' + pct + '%) !important;';
      } else {
        line.classList.remove('cart-drawer__progress-line--filled');
        line.style.cssText = '';
      }
    });

    var highestReached = null;
    for (var i = TIERS.length - 1; i >= 0; i--) {
      if (reached(TIERS[i])) {
        highestReached = TIERS[i];
        break;
      }
    }

    var nextTier = null;
    for (var j = 0; j < TIERS.length; j++) {
      if (!reached(TIERS[j])) {
        nextTier = TIERS[j];
        break;
      }
    }

    if (!nextTier && highestReached) {
      textEl.innerHTML = highestReached.applied || (highestReached.reward + ' applied!');
    } else if (nextTier) {
      var effectiveSub = amountFor(nextTier);
      var remaining = Math.round((nextTier.threshold - effectiveSub) * 100) / 100;
      var rem = remaining % 1 === 0 ? '$' + remaining : '$' + remaining.toFixed(2);
      textEl.innerHTML = 'Add ' + rem + ' for ' + nextTier.reward;
    }
  }

  function fetchAndRender() {
    if (!TIERS) parseTiers();
    if (!TIERS || !TIERS.length) return;

    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          var cart = JSON.parse(xhr.responseText);
          /*
            Two meters:
            - Free shipping: amount PAID after acquisition credits (cart.total_price),
              OR any subscription item in the cart — subscriptions always ship free.
            - Volume 20%/33%: original line totals (subscribe price × qty), before
              automatic volume % and before FRIENDS50. Otherwise 33% off $210
              makes the bar think you are at $140 toward a $300 unlock.
          */
          var merchFull = 0;
          var merchNonBundle = 0;
          var hasSubscription = false;
          if (cart.items && cart.items.length) {
            cart.items.forEach(function (item) {
              var linePrice = volumeProgressCents(item);
              merchFull += linePrice;
              if (!isBundle(item)) merchNonBundle += linePrice;
              if (item.selling_plan_allocation) hasSubscription = true;
            });
          }
          var paidCents = typeof cart.total_price === 'number' ? cart.total_price : merchFull;
          if (paidCents < 0) paidCents = 0;

          updateTierUI(
            merchFull / 100,
            merchNonBundle / 100,
            paidCents / 100,
            Math.min(merchNonBundle, paidCents) / 100,
            hasSubscription
          );
        } catch (e) {}
      }
    };
    xhr.send();
  }

  function setup() {
    if (initialized) return;
    if (!parseTiers()) return;
    initialized = true;

    fetchAndRender();

    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          setTimeout(fetchAndRender, 400);
        });
      }
    } catch (e) {}

    document.addEventListener('cart:refresh', function () {
      setTimeout(fetchAndRender, 400);
    });

    window.addEventListener('microdose:cart-updated', function () {
      setTimeout(fetchAndRender, 200);
    });
  }

  window.__cartTierUpdate = fetchAndRender;

  function trySetup() {
    setup();
    if (!initialized) setTimeout(trySetup, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trySetup);
  } else {
    trySetup();
  }

  setInterval(function () {
    if (!initialized) setup();
    fetchAndRender();
  }, 2000);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) fetchAndRender();
  });
})();
